import {
  PersonPrimaryIdType,
  ServiceAddress,
  PremiseInfo,
  NotificationType,
  CommPreference,
} from '../../__generated__/pge-types';
import { AutoPayConfigData } from '../auto-pay/auto-pay.types';

export enum ServiceSummaryType {
  NEW = 'NEW',
  MOVE = 'MOVE',
  STOP = 'Stop',
}

export type ServiceSummary = {
  type: ServiceSummaryType;
  name?: string;
  account?: string;
  address?: ServiceAddress;
  fromAddress?: string;
  toAddress?: ServiceAddress;
  date?: Date;
  meters?: string[];
  stopDate?: Date;
};

export type ContactInfo = {
  name?: string;
};

export type AccountInfo = {
  address?: string;
  accountNumber?: string;
  premiseInfo?: Array<PremiseInfo>;
  mainCustomerName?: string;
  accountType?: string;
};

export type SSMMoveStayBehind = {
  stayingBehind?: string;
};

export type SSMStopCurrentServiceDate = {
  date?: Date;
};

export type Meter = {
  premiseId: string;
  spId: string;
  spDesc: string;
  spType: string;
  locationDesc: string;
  geolocation: string;
  meterNumber: string;
  disabled: boolean;
  checked: boolean;
  isAreaLight?: boolean;
};

export type AddressAndDate = {
  address?: ServiceAddress;
  date?: Date;
};

export enum PropertyUsageType {
  Own = 'OWN',
  TNT = 'TNT',
  LLD = 'LLD',
  FNF = 'FNF',
}

export type HomeDetails = {
  propertyUsage?: PropertyUsageType;
  serviceAddress?: ServiceAddress;
  goPaperLess?: boolean;
  sameAsServiceAddress?: boolean;
  shouldReceiveNotification?: boolean;
  registeredMobileNumber?: string;
  mailAddress?: string;
  mailCity?: string;
  mailCountry?: string;
  mailQasVerified?: boolean;
  mailState?: string;
  mailZip?: string;
  enrollInGreenFuture?: boolean;
  stayingBehind?: string;
  inCareOf?: string;
};

export type PostEnrollmentPaymentPreferences = {
  preferredDueDate?: number;
  autoPayConfig?: AutoPayConfigData | null;
};

export type NotificationPreference = {
  email: boolean;
  text: boolean;
};

export type NotificationPreferenceObj = {
  [key: string]: {
    [key: string]: boolean;
  };
};

export type AlertStates = {
  [NotificationType.Out]: NotificationPreference;
  [NotificationType.Webpyrem]: NotificationPreference;
  [NotificationType.Webpyrcv]: NotificationPreference;
  [NotificationType.Webpda]: NotificationPreference;
  [NotificationType.Webdisc]: NotificationPreference;
  [NotificationType.Webuse]: NotificationPreference;
  [NotificationType.Webexc]: NotificationPreference;
};

export type PostEnrollmentNotificationSettings = {
  phone?: String;
  email?: String;
  prefLanguage?: string;
  notificationTypes?: AlertStates;
  oldAlertState?: AlertStates;
  originalAlerts?: CommPreference[];
  exceedThreshold?: string;
};

export enum notificationKey {
  OUT = 'OUT',
  WEBPYRCV = 'WEBPYRCV',
  WEBPDA = 'WEBPDA',
  WEBDISC = 'WEBDISC',
  WEBPYREM = 'WEBPYREM',
  WEBUSE = 'WEBUSE',
  WEBEXC = 'WEBEXC',
}

export type PostEnrollmentNotificationSettingsModel = {
  phone: string;
  email: string;
  preferredLanguage?: String;
  prefLanguage: String;
  notificationTypes: AlertStates;
  exceedThreshold: string;
};

export type PostEnrollmentEnrollInPrograms = {
  programs?: string;
};

export type PostEnrollmentCoCustomer = {};

export type SSMCoCustomerInfoFormModel = {
  firstName: string;
  middleName: string;
  lastName: string;
  relationship: string;
  email: string;

  primaryPhone: string;
  useForMobile: boolean;
  mobilePhone: string;
  alternatePhone: string;
};

export type SSMCoCustomerVerificationFormModel = {
  idType:
    | PersonPrimaryIdType.Ssn
    | PersonPrimaryIdType.Dl
    | PersonPrimaryIdType.Matr
    | PersonPrimaryIdType.Pssprt
    | PersonPrimaryIdType.Resalien
    | PersonPrimaryIdType.Visa
    | PersonPrimaryIdType.Military
    | PersonPrimaryIdType.Ortrib
    | PersonPrimaryIdType.Itin;

  idState: string;
  idValue: string;

  birthdate: string;
};

export type SSMAuthUserInfoFormModel = {
  firstName: string;
  middleName: string;
  lastName: string;
  birthDate: string;
  email: string;
  primaryPhone: string;
};
